import script from "./FreshVeg.vue?vue&type=script&setup=true&lang=js"
export * from "./FreshVeg.vue?vue&type=script&setup=true&lang=js"

import "./FreshVeg.vue?vue&type=style&index=0&id=6cef38ca&lang=css"

const __exports__ = script;

export default __exports__